import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { CURRENCY } from '../../../interfaces/enumerables';
import { InvoiceInterface } from '../../../interfaces/invoice.interface';
import { PATHS } from '../../../navigation/data';
import { isDocTypeDeliveryNote } from '../../../services/utils/myDataUtils';
import { getCustomerNewSubtotal } from '../../../services/utils/pdf';
import { LinkTo } from '../../atoms/LinkTo';

interface Props {
  doc: InvoiceInterface;
}

export const DocViewCustomerDebt = ({ doc }: Props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const newTotal = useMemo(() => getCustomerNewSubtotal(doc), [doc]);
  const currencySymbol = useMemo(() => CURRENCY[doc?.currency || 'EUR'], [doc?.currency]);
  const hideSection = useMemo(() => isDocTypeDeliveryNote(doc?.documentType?.aadeCode), [doc?.documentType?.aadeCode]);

  const isPublicDoc = useMemo(() => pathname.includes(PATHS.SHARED_DOC), [pathname]);
  const getSubtotalLinkData = useMemo(() => {
    if (isPublicDoc) return { link: '', data: {} };

    return { link: `${PATHS.MONEY_COLLECTION}/create`, data: { customer: doc.currentCustomer } };
  }, [doc.currentCustomer, isPublicDoc]);

  if (hideSection || doc?.currentSubtotal === null) return null;

  return (
    <div className="flex-start-start-column-nowrap simpleBorder width110">
      <div className="flex-start-start-column-nowrap padding-2">
        <div className="boldText1">{t('SALE.CUSTOMER_DEBT')}</div>
        <div className="normalText1">
          {t('SALE.OLD_DEBT')}:{' '}
          <b>
            {doc?.currentSubtotal} {currencySymbol}
          </b>
        </div>
        <LinkTo link={getSubtotalLinkData.link} data={getSubtotalLinkData.data} classes={'link-reset'}>
          <div className="normalText1 text-blue">
            {t('SALE.NEW_DEBT')}:{' '}
            <b>
              {newTotal} {currencySymbol}
            </b>
          </div>
        </LinkTo>
      </div>
    </div>
  );
};
